<!--赖传峰-->
<!--2022/4/6-->
<template>
  <div
    :class="viewType"
    class="file-item"
  >
    <template v-if="viewType === ViewType.LIST">
      <!--列表视图-->
      <div
        v-if="!isMobile"
        class="checkbox"
        data-disable-swiping
        data-file-toggle-event
      >
        <span
          :class="isSelected ? 'checked' : undefined"
          class="pp-checkbox"
        />
      </div>
      <ElImage
        :src="isFolder(file.kind) ? file.icon_link : (file.thumbnail_link || file.icon_link)"
        :style="isMobile ? 'margin: 0 10px 0 0' : 'margin: 0 20px 0 10px'"
        fit="cover"
        lazy
      >
        <template #placeholder>
          <img
            :alt="file.name"
            :src="file.icon_link"
          >
        </template>
        <template #error>
          <img
            :alt="file.name"
            :src="file.icon_link"
          >
        </template>
      </ElImage>
      <div
        class="file-info"
        @click="preventAndStop"
        @contextmenu="preventAndStop"
      >
        <div class="name-box">
          <div
            :class="props.viewType !== ViewType.SINGLE && 'ellipsis'"
            class="name"
          >
            {{ file.name }}
          </div>
          <i
            v-if="hasSaved && showAfterName"
            class="saved-icon"
          >
            <SavedIcon />
          </i>
        </div>
        <div class="extra-info">
          <i
            v-if="hasSaved && !showAfterName"
            class="saved-icon"
          >
            <SavedIcon />
          </i>
          <div
            v-if="file.size && !isFolder(file.kind)"
            class="size ellipsis"
          >
            {{ storageUnit(Number(file.size)) }}
          </div>
          <div
            v-if="isFolder(file.kind) && pcListViewType"
            class="size ellipsis"
          >
            -
          </div>
          <div class="modified-time ellipsis">
            <ClientOnly :placeholder="FILE_MODIFIED_TIME_PLACEHOLDER">
              {{ dayjs(file.modified_time).format(TIME_FORMAT_STRING) }}
            </ClientOnly>
          </div>
        </div>
      </div>
      <!--桌面端的列表视图操作-->
      <div
        v-if="pcListViewType"
        class="operation"
      >
        <a
          class="pp-link-button"
          @dblclick.prevent.stop
          @contextmenu.prevent.stop="triggerEmmit"
          @click.stop="triggerEmmit"
        >
          <EllipsisIcon color="#a8b2bd" />
        </a>
      </div>
      <!--移动端的列表视图操作-->
      <FileOperation
        v-if="isMobile && props.viewType === ViewType.LIST"
        v-bind="props"
        @click-show-context-menu="(target: Element) => emit('clickShowContextMenu', target, file)"
      />
    </template>
    <template v-if="viewType === ViewType.GRID">
      <div
        data-swiping
        class="thumbnail-wrap"
        data-file-event
      >
        <div class="thumbnail">
          <FolderCover
            v-if="isFolderRef"
            :id="file.id"
            :name="file.name"
            :parent-id="file.parent_id"
            :thumbnail-link="file.thumbnail_link"
          />
          <template v-else>
            <FileCover
              :file-extension="file.file_extension"
              :icon-link="file.icon_link"
              :mime-type="file.mime_type"
              :name="file.name"
              :thumbnail-link="file.thumbnail_link"
            />
            <a
              v-if="showVideoPlayIcon"
              class="play-icon"
              @click="handlePlayIconClick"
            />
          </template>
        </div>
        <div
          v-if="!isMobile"
          class="grid-operation"
        >
          <div
            class="checkbox-wrap"
            data-disable-swiping
            data-file-event
            data-file-toggle-event
          >
            <FileUnCheckedIcon
              v-if="!isSelected"
              class="file-unchecked-icon"
              color="#A8B2BD"
              hover-color="#306EFF"
              hover-able
            />
            <FileCheckedIcon
              v-if="isSelected"
              class="file-checked-icon"
              color="#306EFF"
            />
          </div>
          <a
            v-show="!isMultipleSelected"
            class="pp-link-button"
            @dblclick.prevent.stop
            @contextmenu.prevent.stop="triggerEmmit"
            @click.stop="triggerEmmit"
          >
            <EllipsisIcon
              color="#a8b2bd"
              style="transform: rotate(90deg);"
            />
          </a>
        </div>
      </div>
      <div class="grid-file-info">
        <div class="name">
          <span class="ellipsis">{{ file.name }}</span>
        </div>
        <div class="extra-info">
          <i
            v-if="hasSaved"
            class="saved-icon"
          >
            <SavedIcon />
          </i>
          <div
            v-if="!isFolderRef"
            style="flex-shrink: 0;"
          >
            {{ storageUnit(Number(file.size)) }}
          </div>
          <div class="ellipsis">
            <ClientOnly :placeholder="FILE_MODIFIED_TIME_PLACEHOLDER">
              {{ dayjs(file.modified_time).format(TIME_FORMAT_STRING) }}
            </ClientOnly>
          </div>
        </div>
        <!-- 移动端才会在信息区展示操作 -->
        <div
          v-if="isMobile"
          class="extra-operation"
        >
          <div
            v-if="mobileSelectMode"
            class="checkbox-wrap"
          >
            <span
              :class="isSelected ? 'checked' : undefined"
              class="pp-checkbox"
            />
          </div>
          <a
            v-else-if="!mobileSelectMode"
            class="pp-link-button"
            @dblclick.prevent.stop
            @contextmenu.prevent.stop="triggerEmmit"
            @click.stop="triggerEmmit"
          >
            <EllipsisIcon
              color="#a8b2bd"
              style="transform: rotate(90deg);"
            />
          </a>
        </div>
      </div>
    </template>
    <template v-if="viewType === ViewType.SINGLE">
      <div
        :style="singleMediaFilePadding ? `padding: ${singleMediaFilePadding}px 0` : undefined"
        class="thumbnail-wrap"
        data-file-event
        data-swiping
      >
        <div
          :id="viewType === ViewType.SINGLE ? SINGLE_VIDEO_FILE_THUMBNAIL : undefined"
          class="thumbnail media-file"
        >
          <FileCover
            :file-extension="file.file_extension"
            :icon-link="file.icon_link"
            :mime-type="file.mime_type"
            :name="file.name"
            :thumbnail-link="file.thumbnail_link"
          />
          <a
            v-if="isVideo(file.file_extension, file.mime_type)"
            class="play-icon"
            @click="handlePlayIconClick"
          />
        </div>
        <FileOperation
          v-bind="props"
          @click-show-context-menu="target => emit('clickShowContextMenu', target, file)"
        />
      </div>
      <div
        class="file-info"
        @click="preventAndStop"
        @contextmenu="preventAndStop"
      >
        <div class="name-box">
          <div class="name">
            {{ file.name }}
          </div>
        </div>
        <div class="extra-info">
          <i
            v-if="hasSaved"
            class="saved-icon"
          >
            <SavedIcon />
          </i>
          <div
            v-if="file.size && !isFolder(file.kind)"
            class="size ellipsis"
          >
            {{ storageUnit(Number(file.size)) }}
          </div>
          <div
            v-if="isFolder(file.kind) && pcListViewType"
            class="size ellipsis"
          >
            -
          </div>
          <div class="modified-time ellipsis">
            <ClientOnly :placeholder="FILE_MODIFIED_TIME_PLACEHOLDER">
              {{ dayjs(file.modified_time).format(TIME_FORMAT_STRING) }}
            </ClientOnly>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script
  lang="ts"
  setup
>
import {
  computed,
  onMounted,
  ref,
} from '#imports'
import EllipsisIcon from '@/components/icons/EllipsisIcon.vue'
import FileCheckedIcon from '@/components/icons/FileCheckedIcon.vue'
import FileUnCheckedIcon from '@/components/icons/FileUnCheckedIcon.vue'
import SavedIcon from '@/components/icons/SavedIcon.vue'
import FileCover from '@/components/share/FileCover.vue'
import FileOperation from '@/components/share/FileOperation.vue'
import FolderCover from '@/components/share/FolderCover.vue'
import {
  isFolder,

} from '@/components/share/share.script'
import { useLayout } from '@/store/layout'
import { useShare } from '@/store/share'
import {
  isVideo,
  storageUnit,
} from '@/utils'
import {
  FILE_MODIFIED_TIME_PLACEHOLDER,
  TIME_FORMAT_STRING,
} from '~/types/constants'
import dayjs from 'dayjs'
import { ViewType } from '~/types/enum'

const SINGLE_VIDEO_FILE_THUMBNAIL = 'single_video_file_thumbnail' as const

// eslint-disable-next-line no-spaced-func
const emit = defineEmits<{
  (e: 'clickShowContextMenu', target: Element, file: PPFile): void;
  (e: 'openFile', file: PPFile): void;
}>()
const props = defineProps<{ file: PPFile; viewType: ViewType; mobileSelectMode: boolean; }>()

const singleMediaFilePadding = ref<number>()
const shareStore = useShare()

const isFolderRef = computed(() => isFolder(props.file.kind))

const showVideoPlayIcon = computed(() => isVideo(props.file.file_extension, props.file.mime_type))

const isMobile = computed(() => useLayout().isMobile)
const pcListViewType = computed(() => !isMobile.value && props.viewType === ViewType.LIST)
const isSelected = computed<boolean>(() => shareStore.selectedIds.includes(props.file.id))
const isMultipleSelected = computed<boolean>(() => shareStore.selectedIds.length > 1)
const hasSaved = computed(() => {
  if (shareStore.restoreCache.savedIds) {
    return shareStore.restoreCache.savedIds.includes(props.file.id)
  }
  return false
})

const showAfterName = computed(() => props.viewType === ViewType.LIST && !isMobile.value)

const triggerEmmit = (e: MouseEvent) => emit('clickShowContextMenu', e.target as Element, props.file)

const preventAndStop = (e: MouseEvent) => {
  if (props.viewType !== ViewType.GRID) return
  // 如果是网格模块，事件只应该由缩略图区域触发
  e.preventDefault()
  e.stopPropagation()
}
const handlePlayIconClick = (e: MouseEvent): void => {
  if (props.mobileSelectMode || e.shiftKey || e.ctrlKey || e.metaKey) return

  emit('openFile', props.file)
}

onMounted(() => {
  const offsetHeight = document.body.scrollHeight - window.innerHeight
  const eltHeight = document.getElementById(SINGLE_VIDEO_FILE_THUMBNAIL)?.offsetHeight
  eltHeight && offsetHeight && (singleMediaFilePadding.value = Math.max(360, eltHeight - offsetHeight) / 2)
})

</script>

<style
  lang="less"
  scoped
>
@import '@/assets/styles/util.less';

.file-item {
  &.single {
    --icon-link-size: 80px;
    --play-icon-size: 48px;
    --error-placeholder-image-size: 80px;
  }

  &.grid {
    --icon-link-size: 42px;
    --play-icon-size: 30px;
    --error-placeholder-image-size: 54px;

    margin: 6px 4px;
    padding: 8px;
    border-radius: 12px;

    &.checked {
      background: rgba(48, 110, 255, 0.1) !important;
    }

    &.checked .grid-operation {
      display: block;
    }

    &.checked.current-path {
      box-shadow: 0 0 0 2px rgba(48, 110, 255, 0.4);
    }

    &:hover .grid-operation {
      display: block;
    }
  }

  &.list {
    height: 64px;
    display: flex;
    align-items: center;
    --icon-link-size: 24px;

    .pp-checkbox {
      visibility: hidden;
    }

    .pp-checkbox.checked {
      visibility: visible;
    }

    &:hover {
      .pp-checkbox {
        visibility: visible;
      }
    }

    .file-info {
      margin: 0 0 0 16px;
      flex: 1;
      width: 0;

      .name-box {
        flex: 1;
        display: flex;
        align-items: center;
        overflow: hidden;

        .saved-icon {
          margin-right: 0;
        }
      }

      .name {
        line-height: 18px;
      }

      .extra-info {
        line-height: 13px;
        margin-top: 5px;
      }
    }

    .el-image {
      img {
        width: 100%;
        height: 100%;
      }

      width: var(--icon-link-size);
      height: var(--icon-link-size);
      overflow: hidden;
      border-radius: 4px;
    }
  }
}

.thumbnail-wrap {
  position: relative;
  padding-top: 56.25%; // 相对于宽度的 9/16，子元素使用 position: absolute

  .grid-operation {
    position: absolute;
    width: 100%;
    padding: 0;
    top: 0;
    right: 0;
    display: none;

    .checkbox-wrap {
      position: absolute;
      left: 8px;
      top: 8px;
      background: #fff;
      border-radius: 6px;
      cursor: pointer;
    }

    .pp-link-button {
      position: absolute;
      right: 0;
      top: 8px;
      background: #fff;
      border-radius: 4px;
      width: 24px;
      height: 24px;
      margin-bottom: 8px;
      margin-right: 8px;
      min-width: 24px;
    }
  }
}

.thumbnail {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  border-radius: 8px;
  overflow: hidden;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #e1e6ea;
}

.grid-file-info {
  position: relative;
  margin-top: 8px;

  .name {
    line-height: 24px;
    display: flex;

    width: calc(100% - 24px);
    gap: 6px;
    align-items: baseline;
  }

  .extra-info {
    line-height: 20px;
    font-size: 12px;
    color: var(--color-tertiary-text);
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .saved-icon {
    display: flex;
    width: 16px;
    height: 16px;
  }

  .extra-operation {
    position: absolute;
    width: auto;
    padding: 0;
    top: 4px;
    right: 0;

    .pp-link-button {
      width: 16px;
      border-radius: 4px;
      height: 16px;
      min-width: 16px;
    }
  }
}

.play-icon {
  width: var(--play-icon-size);
  height: var(--play-icon-size);
  position: absolute;
  border-radius: 50%;
  background: url('@/assets/images/player/play.svg') var(--no-repeat-center)/70% fade(#222, 70%);
}

.file-info {
  margin-top: 8px;

  .name {
    line-height: 24px;
  }

  .extra-info {
    line-height: 20px;
    font-size: 12px;
    color: var(--color-secondary-text);
    display: flex;
    align-items: center;

    div + div {
      margin-left: 12px;
    }
  }

  .saved-icon {
    display: flex;
    width: 16px;
    height: 16px;
    margin-right: 4px;
  }

  .modified-time {
    line-height: 20px;
    height: 20px;
  }
}

@media screen and (min-width: @mobile-break-width) {

  .thumbnail {
    border-radius: 16px;
  }

  .file-item {
    &.single {
      --icon-link-size: 120px;
      --play-icon-size: 84px;
      --error-placeholder-image-size: 160px;
    }

    &.grid {
      --icon-link-size: 65px;
      --play-icon-size: 40px;
      --error-placeholder-image-size: 80px;

      padding: 12px;
      border-radius: 20px;

      &:hover {
        background: #f2f3f4;
      }

      .grid-file-info {
        .name {
          align-items: center;
          gap: 8px;
        }
      }

      .file-info {
        .saved-icon {
          margin-right: 2px;
        }
      }

    }

    &.list {
      height: 54px;
      flex: 1;
      --icon-link-size: 26px;

      .file-info {
        display: flex;
        align-items: center;
        margin-left: 0px;

        .name {
          /* flex: 1; */
          padding: 0 8px;
        }

        .extra-info {
          margin-top: 0 !important;

          > div {
            padding: 0 8px;
          }

          .size {
            width: 100px;
          }

          .modified-time {
            width: 200px;
          }
        }
      }

      .operation {
        flex: 0 0 100px;
      }

    }
  }
}

</style>
